import React from 'react';
import { Card, CardContent } from './ui/card';
import { CheckCircle2, Target, Award, Users } from 'lucide-react';

const AboutUs = () => {
  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            About Us
          </h2>
          <p className="text-xl text-gray-600">
            Your trusted partner in exterior cleaning excellence
          </p>
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">
              Who We Are
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              Vancouver House Wash is a locally owned and operated exterior cleaning company dedicated to transforming properties across Metro Vancouver. With over 10 years of experience, we've built our reputation on delivering exceptional results and outstanding customer service.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We specialize in residential and commercial exterior cleaning services, including roof cleaning, gutter maintenance, pressure washing, and more. Our team of trained professionals uses industry-leading equipment to ensure your property looks its best.
            </p>
          </div>
        </div>

        {/* Our Approach */}
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 lg:p-12 border border-green-100">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Our Approach to Quality
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <CheckCircle2 className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    Professional Assessment
                  </h4>
                  <p className="text-gray-700">
                    We begin every job with a thorough inspection to understand your property's unique needs and develop a customized cleaning plan.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <CheckCircle2 className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    Advanced Techniques
                  </h4>
                  <p className="text-gray-700">
                    Using state-of-the-art equipment and proven methods, we deliver superior results while protecting your property and the environment.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <CheckCircle2 className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    Quality Guarantee
                  </h4>
                  <p className="text-gray-700">
                    We stand behind our work with a satisfaction guarantee. If you're not completely happy, we'll make it right.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default AboutUs;